import { render, staticRenderFns } from "./type-group-select.vue?vue&type=template&id=6c18b980&scoped=true&"
import script from "./type-group-select.vue?vue&type=script&lang=js&"
export * from "./type-group-select.vue?vue&type=script&lang=js&"
import style0 from "./type-group-select.vue?vue&type=style&index=0&id=6c18b980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18b980",
  null
  
)

export default component.exports